import React from 'react'
import Chart from "react-apexcharts";

export default function PieChart(props) {
	const chartData = {
		// series: [44, 55, 41, 17, 15],
		series: props.series,
		options: {
			chart: {
				type: 'donut',
			},
			stroke: {
				width: 1,
				// colors: ['#E6E6EA']
			},
			legend: { 
				position: 'right', 
				// width: '120',
				// height: '20'
			}, 
			labels: props.labels,
			plotOptions: {
				pie: {
					donut: {
						size: '53%'
					}
				}
			},
			responsive: [{
                breakpoint: 480,
                options: {
                  chart: {
                    width: 300,
                  },
                  legend: {
                    position: 'bottom'
                  }
                }
            }],
			title: {
				text: `${props.title}`,
				align: 'center'
			},
		},
	};

  	return (
		<div className="donut">
			<Chart options={chartData.options} series={chartData.series} type="donut" height="120%" />
		</div>
  	)
}
